// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__CfI3F","navList":"Nav_navList__Pa5Ia"};